<mat-checkbox
  class="flex items-center py-1"
  [ngClass]="{ invalid: control.invalid && control.touched }"
  [formControl]="control"
  color="primary"
  [disabled]="disabled"
>
  {{ label }}
</mat-checkbox>
